// @flow
import * as React from 'react';
import styled from 'styled-components';
import { identity } from 'lodash';

import { below } from '../../assets/css/media';
import SidebarWidgetCTA from './SidebarWidgetCTA';
import SidebarWidgetHeader from './SidebarWidgetHeader';

const SidebarWidgetCTAStyled = styled(SidebarWidgetCTA)``;

const WidgetWrapper = styled.section`
	width: 100%;
	z-index: 3;
	position: relative;
	display: flex;
	align-items: flex-end;
	flex-direction: column;
	min-height: 115px;
	& + & {
		margin-top: 1px;
		z-index: 1;
	}

	${SidebarWidgetCTAStyled} {
		position: absolute;
		top: 30px;
		right: 20px;
		z-index: 0;
		transition: opacity 0.3s linear;
		${props => props.widget_open && `
			opacity: 0;
		`};
	}

	${props => props.widget_open && below.desktop`
		width: 50vw;
	`};

	${props => props.widget_open && below.tablet`
		width: 80vw;
	`};

`;

const WidgetContent = styled.div`
	width: 100%;
	padding: ${({ no_padding }) => no_padding ? 0 : '20px'};
	box-sizing: border-box;
	visibility: hidden;
	opacity: 0;
	position: relative;
	z-index: 1;
	transition: all 0.3s linear 0.01s;
	min-width: calc(22vw * 0.97);
	min-height: 115px;
	max-height: 115px;
	background-color: white;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);

	${props => props.widget_open && `
		transition-delay: 0.3s;
		visibility: visible;
		opacity: 1;
		max-height: 800px;
		display: flex;
		flex-direction: column;
	`}

	${props => props.widget_open && below.desktop`
		position: fixed;
		top: 0;
		right: 0;
		width: 100%;
		height: 100vh;
		max-height: 100vh;
	`}
`;

const WidgetInnerContent = styled.div`
	overflow-y: auto;
`;

type Props = {
	widget_open: boolean,
	no_padding?:boolean,
	children: React.Node,
	icon: React.Element<any>,
	title: string,
	onOpen?: Function | null,
	onClose?: Function | null,
	onToggle?: Function | null,
	rightIcon?:React.Element<any>
};

const SidebarWidget = ({
	widget_open,
	icon,
	title,
	children,
	onOpen,
	onClose,
	onToggle,
	rightIcon,
	no_padding
}: Props) => {
	const openFunc = onOpen || onToggle || identity;
	const closeFunc = onClose || onToggle || identity;

	return (
		<WidgetWrapper widget_open={widget_open}>
			<SidebarWidgetCTAStyled icon={icon} text={title} onClickCTA={openFunc} />
			<WidgetContent widget_open={widget_open} no_padding={no_padding}>
				<SidebarWidgetHeader
					title={title}
					onClickClose={closeFunc}
					rightIcon={rightIcon}
					add_padding = {no_padding}/>
				<WidgetInnerContent>{children}</WidgetInnerContent>
			</WidgetContent>
		</WidgetWrapper>
	);
};

SidebarWidget.defaultProps = {
	widget_open: false,
	onOpen: null,
	onClose: null,
	onToggle: null,
};

export default SidebarWidget;


// WEBPACK FOOTER //
// ./src/components/SidebarWidget/index.js